import React, { useState, useEffect, useRef } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import Dialog from "@material-ui/core/Dialog";
import { connect } from "react-redux";
import { IDRaksStore } from "../store/store";
import styled from "styled-components";

const ProgressStyle = styled.div`
  .circle {
    margin-left: 36%;
    margin-bottom: 16px;
  }
`;

interface ProgressProps {
  progressText: string;
  isOpen: boolean;
}

export const Progress = ({ isOpen, progressText }: ProgressProps) => {
  const [show, setShow] = useState(false);
  let timeout = useRef(0);

  useEffect(() => {
    if (isOpen) {
      timeout.current = setTimeout(() => {
        setShow(true);
      }, 250);
    } else {
      clearTimeout(timeout.current);
      setShow(false);
    }
    return () => {
      clearTimeout(timeout.current);
    };
  }, [isOpen]);

  return (
    <Dialog open={isOpen && show}>
      <ProgressStyle>
        <DialogContent>
          <CircularProgress color="secondary" size={50} className="circle" />
          <DialogContentText>{progressText}</DialogContentText>
        </DialogContent>
      </ProgressStyle>
    </Dialog>
  );
};

function mapStateToProps(state: IDRaksStore) {
  return {
    progressText: state.ux.progressText,
    isOpen: state.ux.progressCounter > 0
  };
}

export default connect(mapStateToProps)(Progress);
